'use strict';

var cache = {};

module.exports = {
    initTooltipCache: function () {
        cache.$document = $(document);
        cache.tooltipBaseTemplate = '<div class="tooltip bbw-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>';
        cache.tooltipCartTemplate = '<div class="tooltip bbw-tooltip bbw-minicart-tooltip" role="tooltip"><div class="arrow"><div class="arrow-empty"></div></div><div class="tooltip-inner"></div><div class="bbw-tooltip-close-button" role="button"></div></div>';
        cache.tooltipPdpBaseTemplate = '<div class="tooltip bbw-tooltip bbw-pdp-tooltip" role="tooltip"><div class="arrow"><div class="arrow-empty"></div></div><div class="tooltip-inner"></div><div class="bbw-tooltip-close-button" role="button"></div></div>';
        cache.$tooltip = $('.js-tooltip');
        cache.$promoDetailTooltip = $('.js-promo-detail-tooltip');
        cache.$PdpTooltip = $('.js-pdp-tooltip');
    },
    initTooltip: function () {
        this.initTooltipCache();

        cache.$tooltip.tooltip({
            template: cache.tooltipBaseTemplate,
        });
    },
    initPdpTooltip: function (element, containerElement) {
        this.initTooltipCache();

        var selector = element || cache.$PdpTooltip;
        var container = containerElement || selector;

        selector.tooltip({
            offset: '0,5px',
            template: cache.tooltipPdpBaseTemplate,
            trigger: 'manual',
            container: container
        });

        selector.on({
            'mouseenter click': function () {
                $(this).tooltip('show');
            },
            'mouseleave': function () {
                $(this).tooltip('hide');
            }
        });

        $('body').on('click', '.bbw-tooltip-close-button', function () {
            selector.tooltip('hide');
        });
    },
    initPromoDetailTooltip: function (container) {
        this.initTooltipCache();

        cache.$promoDetailTooltip.tooltip({
            template: cache.tooltipPdpBaseTemplate,
            container: container || '.bbw-cart-page',
            offset: '0,5px',
            placement: 'top'
        });
    },
    initPromoDetailTooltipCart: function (container) {
        this.initTooltipCache();

        cache.$promoDetailTooltip.tooltip({
            template: cache.tooltipCartTemplate,
            container: container || '.bbw-cart-page',
            offset: '0,5px',
            placement: 'top'
        });
    },
    initOnEvents: function () {
        var _self = this;

        cache.$document.on('updateCartTotals', function () {
            _self.initPromoDetailTooltip();
        });

        cache.$document.on('updateCartTotals', function () {
            _self.initPromoDetailTooltipCart();
        });

        cache.$document.on('addToBagModal:afterShowModal', function () {
            _self.initPdpTooltip($('.js-pdp-tooltip-bag-modal'));
        });

        cache.$document.on('miniCart:open', function () {
            _self.initPromoDetailTooltipCart('.minicart.bbw-minicart');
        });
    }
};
